import { useEffect, useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import useRoleAccess from "@/hooks/useRoleAccess";
import { Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import {
  ConfigProvider,
  Space,
  Table,
  Tag,
  Input,
  Flex,
  InputNumber,
  Button,
  Alert,
  message,
  DatePicker,
  Select,
  Spin,
} from "antd";
const { TextArea } = Input;

import dayjs from "dayjs";
import formatRupiah from "@/utils/FormatRupiah";

import { ICONS } from "@/assets";
import CustomModal from "@/components/CustomModal";
import ModalAddInhouse from "@/components/CustomModals/ModalAddInhouse";

import { ColumnTransaksiInhouse } from "../../../library/FormColumn";

import { API, URL } from "../../../config/api";

import ButtonExportPDF from "@/components/ButtonExportPDF";
import ButtonExportExcel from "@/components/ButtonExportExcel";

import jsPDF from "jspdf";
import "jspdf-autotable";

import UploadModal from "@/components/uploadPefindoModal"; // ⬅️ Sesuaikan path-nya

import { createStyles } from "antd-style";
import { Link, useNavigate } from "react-router-dom";
const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

const InhousePage = () => {
  const [branch, setBranch] = useState(null);
  const [status, setStatus] = useState(null);
  const [dateRange, setDateRange] = useState(null); // [start, end]
  const { isViewer } = useRoleAccess();


  const branchOptions = [
    { value: "jakarta", label: "Jakarta" },
    { value: "bandung", label: "Bandung" },
    { value: "surabaya", label: "Surabaya" },
  ];

  const statusOptions = [
    { value: "CRA", label: "Credit Review" },
    { value: "APPV-1", label: "Approval 1" },
    { value: "APPV-2", label: "Approval 2" },
    { value: "APPV-3", label: "Approval 3" },
    //   { value: "FA", label: "Final Approval" },
    //   { value: "Rejected", label: "Rejected" },
  ];

  const { styles } = useStyle();

  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  const [modalType, setModalType] = useState(null);
  const [selectedData, setSelectedData] = useState(null);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [uploadingRow, setUploadingRow] = useState(null);

  const [dataPasangan, setDataPasangan] = useState([]);

  // useEffect(() => {
  //   const fetchOptions = async () => {
  //     setLoading(true);
  //     try {final
  //       const res = await API.get(URL.MASTER_ACC);
  //       const data = res.data.data;

  //       // Transformasi data agar sesuai format options Select
  //       const formattedOptions = data.map((item) => ({
  //         value: item.id,
  //         label: `${item.nameAcc} - ${item.noAcc}`,
  //         noAcc: item.noAcc,
  //         nameAcc: item.nameAcc,
  //       }));

  //       setOptions(formattedOptions);
  //     } catch (error) {
  //       console.error("Error fetching options:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchOptions();
  // }, []);

  // const handleUpload = async (e, record) => {
  //   const file = e.target.files[0];
  //   if (!file) return;

  //   setUploadingRow(record.application_id); // tandai row yang sedang upload

  //   try {
  //     const formData = new FormData();
  //     formData.append("file", file);

  //     const API_BASE_URL = import.meta.env.VITE_BASE_URL2;

  //     const res = await fetch(
  //       `${API_BASE_URL}/api/upload/${record.application_id}/${record.nik}`,
  //       {
  //         method: "POST",
  //         body: formData,
  //       }
  //     );

  //     if (res.ok) {
  //       message.success("Upload berhasil!");
  //       getData(); // refresh data agar tombol download langsung muncul
  //     } else {
  //       message.error("Upload gagal!");
  //     }
  //   } catch (err) {
  //     console.error("Upload error:", err);
  //     message.error("Terjadi kesalahan saat upload!");
  //   } finally {
  //     setUploadingRow(null);
  //     e.target.value = ""; // reset input biar bisa upload file yang sama lagi
  //   }
  // };

  const [uploadVisible, setUploadVisible] = useState(false);
  const [uploadData, setUploadData] = useState({
    applicationId: null,
    nik: null,
    nama: null,
    nikpasangan: null,
    namaPasangan: null,
  });

  const handleUpload = (record) => {
    setUploadData({
      applicationId: record.application_id,
      nik: record.nik,
      nama: record.nama,
      nikpasangan: record.nikpasangan,
      namaPasangan: record.namapasangan,
    });
    setUploadVisible(true);
  };

  const handleChange = (value, name) => {
    console.log("value change", value);
    console.log("name change", name);
    setSelectedData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const closeModal = () => {
    setModalType(null);
    setSelectedData(null);
    setIsAddOpen(false);
    setIsEditOpen(false);
  };

  useEffect(() => {
    console.log("type", modalType);
  }, [modalType]);

  const handleModal = (type, record) => {
    setModalType(type);
    setSelectedData(record); // Simpan data baris yang dipilih
    console.log("record", record);
  };

  const openAddModal = () => {
    setModalType(null); // Set modal untuk Add
    setIsEditOpen(false);
    setIsAddOpen(true);
    setSelectedData(null);
  };

  const openEditModal = (data) => {
    setModalType(null); // Set modal untuk Edit
    setIsAddOpen(false);
    setIsEditOpen(true);

    setSelectedData(data);
  };

  const handleSubmit = async (values) => {
    console.log("isAddOpen", isAddOpen);
    console.log("Form Submitted:", values);

    try {
      // await API.post(URL.TRX_INHOUSE + "/add", values);

      setSelectedData(null); // Update data for Edit modal
      getData();
      successMsg();
      closeModal();
      return;
    } catch (error) {
      console.error("Error submitting form:", error);
      message.error("Gagal menambahkan data!");
    }
  };

  // const getData = async () => {
  //   try {
  //     // const res = await API.get(URL.TRX_INHOUSE);
  //     // setData(res.data.data);
  //     setData([{ id: 1 }]);
  //   } catch (error) {
  //     console.error("Error fetching account data:", error);
  //     errorMsg();
  //   }
  // };

  // const getData = async () => {
  //   try {
  //     const params = {
  //       branch,
  //       status,
  //       startDate: dateRange?.[0]?.format("YYYY-MM-DD"),
  //       endDate: dateRange?.[1]?.format("YYYY-MM-DD"),
  //     };

  //     // const res = await API.get(URL.TRX_INHOUSE, { params });
  //     // setData(res.data.data);

  //     console.log("Fetching data with filters:", params);
  //     // setData([{ id: 1, tgl: "2024-06-12", noAcc: "001", nameAcc: "Kas", keterangan: "Test", kategori: "Debit", amount: 100000 }]);
  //     setData([
  //       {
  //         id: 1,
  //         nama: "Musyaffa Nur Ihsanuddin",
  //         nik: "3278030402910003",
  //         alamat: "Cilebut",
  //         pefindo: "https://google.com",
  //         slik: "https://google.com",
  //         is_survey: 1,
  //         // pasangan: {
  //         //   namapasangan: "Azzahra",
  //         // },
  //       },
  //     ]);
  //   } catch (error) {
  //     console.error("Error fetching account data:", error);
  //     errorMsg();
  //   }
  // };

  const getData = async () => {
    setLoading(true);
    try {
      const API_BASE_URL = import.meta.env.VITE_BASE_URL2;

      // const res = await fetch("http://217.196.49.162:3001/api/getlist");
      const res = await fetch(`${API_BASE_URL}/api/getListPemohonPasangan`);
      // VITE_BASE_URL2 = "https://api2.cf.gratama-finance.co.id"
      const json = await res.json();

      // Gabungkan seluruh array di dalam object menjadi satu array
      const mergedData = Object.values(json)
        .filter(Array.isArray) // hanya ambil yang array
        .flat(); // gabung array menjadi satu

      setData(mergedData);
    } catch (error) {
      console.error("Error fetching pemohon list:", error);
      errorMsg();
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   getData();
  // }, []);

  useEffect(() => {
    if(!isViewer)
    getData();
  }, [branch, status, dateRange]);

  console.log("selectedData", selectedData);

  const optionsKategori = [
    { value: "Debit", label: "Debit" },
    { value: "Kredit", label: "Kredit" },
  ];

  // const actionColumn = {
  //   title: "Action",
  //   key: "action",
  //   fixed: "right",
  //   align: "center",
  //   // width: 100,
  //   render: (_, record) => (
  //     <Space size="middle">
  //     <Link to={`/approval/detail/${record.application_id}/${record.nik}`}>
  //       <img src={ICONS.FaDetail} alt="View" />
  //     </Link>
  //     </Space>
  //   ),
  // };

  const renderContent = () => {
    if (modalType === "view") {
      return (
        <>
          <Flex vertical gap={12}>
            <div className="flex gap-4">
              <div>
                <label>No. Anggota :</label>
                <Input
                  name="noAnggota"
                  value={selectedData && selectedData?.noAnggota}
                  size="large"
                  className="mt-1"
                  readOnly
                />
              </div>
              <div>
                <label>No. Simpanan :</label>
                <Input
                  name="noSimpanan"
                  value={selectedData && selectedData?.noSimpanan}
                  size="large"
                  className="mt-1"
                  readOnly
                />
              </div>
            </div>
          </Flex>
        </>
      );
    } else if (modalType === "pasangan") {
      return (
        <>
          <Flex vertical gap={12}>
            <ConfigProvider
              theme={{
                components: {
                  Table: {
                    colorPrimary: "#0164A2",
                    headerColor: "#fff",
                    headerBg: "#0164A2",
                    headerBorderRadius: 6,
                    algorithm: true,
                    // borderColor: "#000",
                  },
                  Pagination: {
                    colorPrimary: "#0164A2",
                    colorPrimaryHover: "#0164A2",
                    colorPrimaryBorder: "#0164A2",
                    algorithm: true,
                  },
                },
              }}
            >
              <Table
                className={styles.customTable}
                columns={columnDataPasangan}
                dataSource={dataPasangan}
                size="middle"
                scroll={{
                  x: "max-content",
                  // y: 55 * 5,
                }}
              />
            </ConfigProvider>
          </Flex>
        </>
      );
    }
    return null; // No form for delete modal
  };

  const columnDataPasangan = [
    {
      title: "NAMA",
      dataIndex: "namapasangan",
      key: "namapasangan",
      // render: (text) => <a>{text}</a>,
    },
    {
      title: "NIK",
      dataIndex: "nikpasangan",
      key: "nikpasangan",
    },
    {
      title: "NO. HP",
      dataIndex: "nohppasangan",
      key: "nohppasangan",
      render: (text) => <a>{text || "-"}</a>,
    },

    {
      title: "PEFINDO",
      dataIndex: "uri_slik",
      key: "uri_slik",
      render: (text) =>
        text ? (
          <a
            href={text}
            target="_blank"
            rel="noreferrer"
            style={{ color: "blue", textDecoration: "underline" }}
          >
            Download
          </a>
        ) : (
          "-"
        ),
    },
  ];

  const openDetailSimpWajibModal = (data) => {
    setModalType("pasangan");
    setSelectedData(data);
    // Ambil hanya data pasangan dari objek pemohon
    setDataPasangan([
      {
        namapasangan: data.namapasangan,
        nikpasangan: data.nikpasangan,
        nohppasangan: data.nohppasangan,
        // summary_slik: data.summary_slik_pasangan,
        // uri_slik: data.uri_slik_pasangan,
      },
    ]);
  };

  const colomnMaritalStatus = [
    {
      title: "MARITAL STATUS",
      dataIndex: "statuspernikahan",
      key: "statuspernikahan",
      render: (text, record) => (
        <button
          onClick={() => openDetailSimpWajibModal(record)}
          className="text-blue-500 underline semibold"
        >
          {text}
        </button>
      ),
    },
    {
      title: "NOMOR HP",
      dataIndex: "nohp",
      key: "nohp",
      render: (text) => <a>{text || "-"}</a>,
    },
    {
      title: "STATUS",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        const cleaned = text?.replace(/\s+/g, ""); // hilangkan spasi jika ada

        const statusLabelMap = {
          CRA: "Credit Review Analis",
          "APPV-1": "APPROVAL 1",
          "APPV-2": "APPROVAL 2",
          "APPV-3": "APPROVAL 3",
          FA: "FINAL APPROVE",
          Rejected: "REJECTED",
        };

        const statusColorMap = {
          CRA: "#ff4d4f", // Merah terang (butuh perhatian)
          "APPV-1": "rgba(255, 102, 0, 1)", // Kuning (review/pertimbangan)
          "APPV-2": "#ffff00", // Hijau muda (positif, lanjut)
          "APPV-3": "#00ff00", // Hijau tua (final, disetujui)
          FA: "#0000ff",
        };

        const label = statusLabelMap[cleaned] || text;
        const bgColor = statusColorMap[cleaned] || "#d9d9d9";
        // const textColor = cleaned === 'APPV-3' ? '#fff' : '#000' || 'APPV-2' ? '#fff' : '#000'; // biar hijau tua tetap kebaca
        // const textColor = cleaned === 'APPV-2' ? '#000' : '#fff' || cleaned === 'APPV-3' ? '#000' : '#fff';

        const darkTextStatuses = ["APPV-2", "APPV-3"];
        const textColor = darkTextStatuses.includes(cleaned) ? "#000" : "#fff";

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "4px",
              fontWeight: "bold",
              fontSize: "12px", // ukuran font lebih kecil
              display: "inline-block", // penting agar width bekerja
              width: "150px", // sesuaikan lebar sesuai kebutuhan
              textAlign: "center", // agar teks di tengah
            }}
          >
            {label}
          </span>
        );
      },
    },
  ];

  const actionColumn = {
    title: "Action",
    key: "action",
    fixed: "right",
    align: "center",
    render: (_, record) => {
      console.log("record", record);
      const isUploaded = !!record.uri_pefindo;

      return (
        <Space>
          {/* Tombol Detail */}
          <div className="flex justify-center items-center gap-4">
            <Link
              to={`/approval/detail/${record.application_id}/${record.nik}`}
            >
              <Button
                shape="circle"
                icon={<img src={ICONS.FaDetail} alt="View" />}
              />
            </Link>

            <Button
              type="primary"
              icon={<UploadOutlined />}
              onClick={() => handleUpload(record)}
              disabled={isUploaded || isViewer}
              className={`flex items-center justify-center ${
                isUploaded ? "bg-gray-400 cursor-not-allowed" : "bg-blue-500"
              }`}
              title="Upload SLIK"
              shape="circle"
            />
          </div>

          {/* Tombol Upload (persis index_order, hanya icon, biru) */}
          {/* <label>
            <input
              type="file"
              style={{ display: "none" }}
              onChange={(e) => handleUpload(e, record)}
            />
            <Button
              type="primary"
              size="small"
              loading={uploadingRow === record.application_id}
              className="bg-blue-600 text-white"
            >
              <img src={ICONS.FaUpload} alt="Upload" />
            </Button>
          </label> */}
        </Space>
      );
    },
  };

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const runningNumberColumn = {
    title: "No",
    key: "no",
    render: (text, record, index) =>
      (pagination.current - 1) * pagination.pageSize + index + 1,
    width: 50,
    align: "center",
  };

  const extendedColumn = [
    runningNumberColumn,
    ...ColumnTransaksiInhouse.columns,
    ...colomnMaritalStatus,
    actionColumn,
  ];

  const [messageApi, contextHolder] = message.useMessage();

  const successMsg = () => {
    messageApi.open({
      type: "success",
      content: "Success create data",
    });
  };
  const successUpdateMsg = () => {
    messageApi.open({
      type: "success",
      content: "Success update data",
    });
  };

  const errorMsg = () => {
    messageApi.open({
      type: "error",
      content: "Data is empty",
    });
  };

  const successMsgDelete = () => {
    messageApi.open({
      type: "success",
      content: "Success delete data",
    });
  };

  const exportPDF = () => {
    // console.log(data);
    if (data != "") {
      const doc = new jsPDF();

      // Ambil header dari kolom tabel Ant Design
      const headers = ColumnTransaksiInhouse.columns.map((col) => col.title);

      // Ambil data dari `dataSource`
      const body = data.map((row) =>
        // ColumnTransaksiInhouse.columns.map((col) => row[col.dataIndex])
        ColumnTransaksiInhouse.columns.map((col) =>
          col.dataIndex === "amount"
            ? formatRupiah(row[col.dataIndex])
            : row[col.dataIndex]
        )
      );

      // Gunakan `autoTable` untuk membuat PDF
      doc.autoTable({
        head: [headers],
        body: body,
      });

      // Simpan file PDF
      doc.save("Laporan Keuangan.pdf");
    } else {
      errorMsg();
      console.log("error");
    }
  };

  const exportToExcel = async () => {
    const date = dayjs(); // Get current date
    const getMonthName = date.format("MMM");
    const formattedDate = date.format("MMM-YY");

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(getMonthName);

    // Tambahkan header utama
    worksheet.mergeCells("A1:F1");
    const header1 = worksheet.getCell("A1");
    header1.value = "TRANSAKSI INHOUSE";
    header1.font = { bold: true, size: 24 };
    header1.alignment = { horizontal: "center", vertical: "middle" };
    header1.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };
    header1.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.mergeCells("A2:H2");
    const header3 = worksheet.getCell("A2");
    header3.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "ffffff" }, // white background
    };

    // Tambahkan sub-header dengan tanggal
    worksheet.mergeCells("A3:F3");
    const header2 = worksheet.getCell("A3");
    header2.value = formattedDate;
    header2.font = { bold: true, size: 32 };
    header2.alignment = { horizontal: "center", vertical: "middle" };
    header2.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFBDD7EE" }, // Light blue background
    };
    header2.border = {
      top: { style: "medium" },
      left: { style: "medium" },
      bottom: { style: "medium" },
      right: { style: "medium" },
    };

    worksheet.getRow(4).height = 25;

    // Tambahkan header kolom
    const headers = [
      "TANGGAL",
      "NOMOR AKUN",
      "NAMA AKUN",
      "KETERANGAN",
      "KATEGORI",
      "AMOUNT",
    ];
    headers.forEach((header, index) => {
      const cell = worksheet.getCell(4, index + 1); // Baris ke-3 untuk header kolom
      cell.value = header;
      cell.font = { bold: false, size: 12 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFBDD7EE" }, // Light blue background
      };
      cell.border = {
        top: { style: "medium" },
        left: { style: "medium" },
        bottom: { style: "medium" },
        right: { style: "medium" },
      };
    });

    data.forEach((item, rowIndex) => {
      const row = worksheet.getRow(5 + rowIndex); // Data dimulai dari baris ke-4
      row.getCell(1).value = item.tgl;
      row.getCell(2).value = item.noAcc;
      row.getCell(3).value = item.nameAcc;
      row.getCell(4).value = item.keterangan;
      row.getCell(5).value = item.kategori;
      row.getCell(6).value = item.amount;

      row.getCell(1).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(2).alignment = { horizontal: "center", vertical: "middle" };
      row.getCell(5).alignment = { horizontal: "center", vertical: "middle" };

      // Format untuk nilai angka (Debet, Kredit, Saldo)
      row.getCell(6).numFmt = "Rp #,##0.00;[Red]-Rp #,##0.00";

      const capitalizeText = (text) =>
        text.replace(/\b\w/g, (char) => char.toUpperCase());

      row.getCell(5).value = capitalizeText(row.getCell(5).value);
      row.getCell(5).font = { bold: true, size: 12 };

      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      // Loop through cells 1 to 5 and apply the border style
      for (let i = 1; i <= headers.length; i++) {
        row.getCell(i).border = borderStyle;
      }
    });

    // Atur lebar kolom
    worksheet.columns = [
      { width: 15 },
      { width: 15 },
      { width: 25 },
      { width: 40 },
      { width: 20 },
      { width: 20 },
    ];

    // Generate file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `Laporan Transaksi Inhouse.xlsx`);
  };

  const [searchTerm, setSearchTerm] = useState("");

  const loginUser = localStorage.getItem("username");

  const userStatusMap = {
    indra_hartanto: "APPV-1",
        g_prastiwi: "APPV-1",
            deo: "APPV-1",
    dian_andrianza: "APPV-2",
    sastra_hamidjaja: "APPV-3",
  };
  return (
    <div>
      {uploadVisible && (
        <UploadModal
          visible={uploadVisible}
          onClose={() => setUploadVisible(false)}
          onSuccess={getData} // ← panggil ulang data
          applicationId={uploadData.applicationId}
          nik={uploadData.nik}
          nama={uploadData.nama}
          nikpasangan={uploadData.nikpasangan}
          namaPasangan={uploadData.namaPasangan}
        />
      )}

      {contextHolder}

      <h1 className="text-4xl font-semibold mb-8">APPROVAL TASK LIST</h1>
      <div className="flex gap-4">
        <ButtonExportPDF onClick={exportPDF} />
        <ButtonExportExcel onClick={exportToExcel} />
      </div>
      <div className="flex justify-between">
        {
          /* <Button
          type="primary"
          size="large"
          // onClick={() => handleModal("add", {})}
          onClick={() => openAddModal()}
          // onClick={() => setModalType("add")}
          className=" bg-primary text-white py-2 px-4 rounded-md mb-4"
        >
          Tambah Data
        </Button> */

          <div className="flex flex-wrap gap-4 mb-4">
            {/* <Select
              allowClear
              style={{ width: 200 }}
              placeholder="Pilih Cabang"
              options={branchOptions}
              value={branch}
              onChange={(val) => setBranch(val)}
            /> */}

            {/* <DatePicker.RangePicker
              format="DD/MM/YYYY"
              value={dateRange}
              onChange={(val) => setDateRange(val)}
              style={{ width: 300 }}
            /> */}

            <Input
              allowClear
              placeholder="Cari application ID / NIK / Nama"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: 300 }}
            />

            <Select
              allowClear
              style={{ width: 200 }}
              placeholder="Pilih Status"
              options={statusOptions}
              value={status}
              onChange={(val) => setStatus(val)}
            />

            <Button
              type="primary"
              onClick={() => getData()}
              className="bg-blue-600 text-white"
            >
              Filter
            </Button>
          </div>
        }
      </div>

      <ConfigProvider
        theme={{
          components: {
            Table: {
              colorPrimary: "#0164A2",
              headerColor: "#fff",
              headerBg: "#0164A2",
              headerBorderRadius: 6,
              algorithm: true,
              // borderColor: "#000",
            },
            Pagination: {
              colorPrimary: "#0164A2",
              colorPrimaryHover: "#0164A2",
              colorPrimaryBorder: "#0164A2",
              algorithm: true,
            },
          },
        }}
      >
        <Table
          className={styles.customTable}
          columns={extendedColumn}
          loading={loading}
          //   dataSource={data.filter((item) => {
          //   const term = searchTerm.toLowerCase();

          //   const matchSearch =
          //     item.application_id?.toLowerCase().includes(term) ||
          //     item.nik?.toLowerCase().includes(term) ||
          //     item.nama?.toLowerCase().includes(term);

          //   const matchStatus = status ? item.status?.toLowerCase() === status.toLowerCase() : true;

          //   return matchSearch && matchStatus;
          // })}

          // dataSource={data.filter((item) => {
          //   const term = searchTerm.toLowerCase();

          //   const matchSearch =
          //     item.application_id?.toLowerCase().includes(term) ||
          //     item.nik?.toLowerCase().includes(term) ||
          //     item.nama?.toLowerCase().includes(term);

          //   const matchStatus = status
          //     ? item.status?.toLowerCase() === status.toLowerCase()
          //     : true;

          //   const excludeFA =
          //     item.status !== "FA" && item.status !== "REJECTED"; // Ini yang ditambahkan

          //   return matchSearch && matchStatus && excludeFA;
          // })}

dataSource={data.filter((item) => {
  const term = (searchTerm || "").toLowerCase();

  const matchSearch =
    item.application_id?.toLowerCase().includes(term) ||
    item.nik?.toLowerCase().includes(term) ||
    item.nama?.toLowerCase().includes(term);

  const matchStatus = status
    ? item.status?.toLowerCase() === status.toLowerCase()
    : true;

  // ambil role dari localStorage (key: "rolenya")
  const role = localStorage.getItem("rolenya");
  // const role = rawRole ? rawRole.toString().trim().toUpperCase() : null;

  // normalisasi status item juga
  const itemStatus = item.status ? item.status.toString().trim().toUpperCase() : "";

  let roleMatch = true;

  // mapping sesuai instruksi:
  // approver1 => APPV-1
  // approver2 => APPV-2
  // approver3 => APPV-2
  // credit_analyst => CRA
  // selain itu => semua status
  if (role === "approver1") {
    roleMatch = itemStatus === "APPV-1" || itemStatus === "CRA";
  } else if (role === "approver2") {
    roleMatch = itemStatus === "APPV-2" 
    //|| itemStatus === "CRA";
  }
   else if (role === "approver3") {
    roleMatch = itemStatus === "APPV-3" 
    //|| itemStatus === "CRA";
  }
  else if (role === "credit_analyst" || role === "CREDIT-ANALYST" || role === "CREDIT_ANALYST") {
    roleMatch = itemStatus === "CRA";
  } else {
    // selain role-role di atas -> boleh lihat semua status
    roleMatch = true;
  }

  return matchSearch && matchStatus && roleMatch;
})}




          // dataSource={data.filter((item) => {
          //   const term = searchTerm.toLowerCase();

          //   const matchSearch =
          //     item.application_id?.toLowerCase().includes(term) ||
          //     item.nik?.toLowerCase().includes(term) ||
          //     item.nama?.toLowerCase().includes(term);

          //   const matchStatus = status
          //     ? item.status?.toLowerCase() === status.toLowerCase()
          //     : true;

          //   const excludeFA = item.status !== "FA" && item.status !== "REJECTED";

          //   // === Tambahan: filter sesuai login user ===
          //   const userMatch = item.status === userStatusMap[loginUser];

          //   return matchSearch && matchStatus && excludeFA && userMatch;
          // })}
        />
      </ConfigProvider>

      {/* <ModalAddInhouse
        key={isAddOpen ? "add" : "hidden"}
        visible={isAddOpen}
        onClose={closeModal}
        title="Tambah Transaksi"
        // content={renderContent()}
        onSave={handleSubmit}
      /> */}

      <CustomModal
        key={modalType === "pasangan" && true}
        visible={modalType && modalType === "pasangan"}
        onClose={closeModal}
        title="Detail Pasangan"
        content={renderContent()}
        showFooter={false} // No buttons for View mode
        readOnly={true} // Form is read-only
      />
    </div>
  );
};

export default InhousePage;
